import { styled } from "@mui/material";
import PageContainer from "@pageContent/common/PageContainer";
import { colors, fonts } from "@constants/cssVariables";

export const SeasonCollectionContainer = styled(PageContainer)(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(15),
}));

export const TitleContainer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(4),
  marginBottom: theme.spacing(6),
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    marginBottom: theme.spacing(4),
    flexDirection: "column-reverse",
    alignItems: "baseline",
  },
}));

export const Title = styled("h3")({
  font: fonts.header3,
  color: colors.neutral90,
  flex: 1,
});

export const LoadMoreContainer = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(6),
  textAlign: "center",
}));

export const NoResultText = styled("p")({
  font: fonts.bodyLarge,
  color: colors.neutral90,
});
